import React from 'react';
import { FileTextIcon } from 'lucide-react';
export function I3SeriesSection() {
  return <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-397">
      <div className="bg-[#002d4d] text-white py-6 px-8 flex flex-col md:flex-row md:items-center justify-between" data-id="element-398">
        <div data-id="element-399">
          <h2 className="text-3xl font-bold mb-1" data-id="element-400">Bodor i3 Series</h2>
          <h3 className="text-white/80 font-medium text-lg" data-id="element-401">
            Compact design, high-speed sheet fiber laser metal cutting machine
          </h3>
        </div>
      </div>

      <div className="p-8" data-id="element-402">
        <div className="grid md:grid-cols-12 gap-12 items-center mb-10" data-id="element-403">
          <div className="md:col-span-5 flex flex-col items-center bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-404">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/BODOR/2023/Fiber%20Laser%20Bodor%20iSeries.png800x800.png" alt="Bodor i3 Series" className="block max-h-[350px] w-auto object-contain drop-shadow-xl mb-4" data-id="element-405" />
            <span className="bg-[#f5693d] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-406">
              Smart, Ultra-Precise
            </span>
          </div>
          <div className="md:col-span-7" data-id="element-407">
            <ul className="space-y-4 text-gray-700" data-id="element-408">
              <li data-id="element-409">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-410">
                  A Compact Design with Complete Protection
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-411">
                  Small occupied space balances complete protection and higher
                  safety.
                </span>
              </li>
              <li data-id="element-412">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-413">
                  Active Anti-collision Function
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-414">
                  Effectively reduce the damage rate of laser heads, help you
                  save maintenance cost.
                </span>
              </li>
              <li data-id="element-415">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-416">
                  Linear Motor
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-417">
                  Linear Motor has the advantage of contactless transmission,
                  low inertia ratio, and high speed dynamic response.
                </span>
              </li>
              <li data-id="element-418">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-419">
                  Marble Bed
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-420">
                  100 times more vibration damping coefficient than steel!
                  Marble workbench keeps the equipment stable.
                </span>
              </li>
              <li data-id="element-421">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-422">
                  High Speed Cutting Database
                </strong>
              </li>
              <li data-id="element-423">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-424">
                  No Quiver when Cutting Thin Sheet
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-425">
                  i Series are capable of cutting edges of thin sheet and ensure
                  no quivering marks.
                </span>
              </li>
              <li data-id="element-426">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-427">
                  Bodor Pro 2.0
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-428">
                  CAD and CAM are embedded perfectly in Bodor Pro 2.0 to help
                  you edit graphics. No more extra editing software required.
                </span>
              </li>
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 mt-8 pt-6 border-t border-gray-100" data-id="element-429">
              <a href="https://www.peakedm.com/m7/Bodor%20I3%20Linear--i3-ultra-precise-linear-drive-fiber-laser-cutter.html" className="inline-flex items-center justify-center px-6 py-3 bg-[#002d4d] text-white font-bold uppercase text-sm rounded-md hover:bg-[#f5693d] transition-colors" data-id="element-430">
                <span className="mr-2" data-id="element-431">+</span> Discover More
              </a>
              <a href="https://www.peakedm.com/uploaded/files/Bodor%20Files/Bodor%20i%20series%20precision%20laser%20cutting%20machine.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border-2 border-[#002d4d] text-[#002d4d] font-bold uppercase text-sm rounded-md hover:bg-[#002d4d] hover:text-white transition-colors" data-id="element-432">
                <FileTextIcon className="w-4 h-4 mr-2" data-id="element-433" /> Download Brochure
              </a>
            </div>
          </div>
        </div>

        <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm" data-id="element-434">
          <table className="w-full text-sm text-left text-gray-600" data-id="element-435">
            <thead className="text-xs text-gray-700 uppercase bg-gray-100 border-b border-gray-200" data-id="element-436">
              <tr data-id="element-437">
                <th scope="col" className="px-6 py-4 font-bold border-r border-gray-200 w-1/2" data-id="element-438">
                  Model
                </th>
                <th scope="col" className="px-6 py-4 font-bold text-center w-1/2" data-id="element-439">
                  i3Linear
                </th>
              </tr>
            </thead>
            <tbody data-id="element-440">
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-441">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-442">
                  Working Area
                </th>
                <td className="px-6 py-4 text-center" data-id="element-443">600*600mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-444">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-445">
                  Laser Power
                </th>
                <td className="px-6 py-4 text-center" data-id="element-446">3000w/2000w/1500w</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-447">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-448">
                  X/Y-axis positioning accuracy
                </th>
                <td className="px-6 py-4 text-center" data-id="element-449">0.01mm</td>
              </tr>
              <tr className="bg-white border-b border-gray-200 hover:bg-gray-50" data-id="element-450">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-451">
                  X/Y-axis repositioning accuracy
                </th>
                <td className="px-6 py-4 text-center" data-id="element-452">0.004mm</td>
              </tr>
              <tr className="bg-white hover:bg-gray-50" data-id="element-453">
                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap border-r border-gray-200 bg-gray-50/50" data-id="element-454">
                  X/Y-axis Max. linkage speed
                </th>
                <td className="px-6 py-4 text-center" data-id="element-455">80m/min</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}